import { Box, Typography } from "@mui/material";
/* eslint-disable max-len */
import React, { FC } from "react";
import { colorTheme, getSOCStatusDataMap } from "../../utils/SOCUtils";

import { ChipCustom } from "../../styles/styledComponents";
import { CustomToolTip } from "../../shared/containers/EditHospitalContainer/EditHospitalContainer.style";
import { Image } from "../CardGeneric/CardGeneric.style";
import SocStatusCustomIcon from "../Icons/SocStatusCustomIcon";

interface IPetCard {
  petImageUrl?: string
  petName: string
  socStatus: string // "default" | "Overdue" | "Incomplete" | "Current" | "Almost Due"
  lastVisitDate?: string
  petId: string
  onClick: (petId: string) => void
}

const PetCard: FC<IPetCard> = (props) => {
  return (
    <>
      <div
        className="rounded-xl overflow-hidden relative h-[16rem] cursor-pointer
        hover:border hover:border-dark-gv-yellow hover:bg-gv-yellow-light hover:opacity-60"
        onClick={() => props.onClick(props.petId)}
      >
        <img
          src={props.petImageUrl ? props.petImageUrl : "/assets/icons/pet-placeholder.jpg"}
          className="!h-full !w-full object-cover overflow-hidden"
        />
        <div className="absolute top-0 h-webkit-fill-available w-webkit-fill-available
        flex flex-col justify-between">
          <div className="pt-2 px-2 flex justify-end">
            <ChipCustom
              icon={<SocStatusCustomIcon type={props.socStatus as keyof typeof colorTheme} />}
              label={getSOCStatusDataMap(props.socStatus).label}
              className="!font-semibold !text-xs !py-[0.375rem] !px-2"
              color={getSOCStatusDataMap(props.socStatus).color}
              size="small"
            />
          </div>
          <div className={`text-white py-2 px-2
            ${props.petImageUrl ? "bg-gradient-to-t from-brownish-black to-100%" : ""}`}
          >
            <div className="flex gap-2">
              <h3 className="text-2xl font-semibold">{props.petName}</h3>
              {!props.petImageUrl &&
              <CustomToolTip
                title={
                  <Typography color="inherit">
                            Complete{` ${props.petName}'s`}  profile.
                  </Typography>
                }
                placement="top"
                sx={{ marginLeft: "1rem !important" }}
              >
                <Box className="cursor-pointer">
                  <Image src="/assets/icons/Notification bubble.svg" className="!w-4 !h-4 mt-2" alt={"info"}/>
                </Box>
              </CustomToolTip>}
            </div>
            <p className="text-xs font-normal">{props.lastVisitDate} &#x2022; Last Visit</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PetCard;
